import { createApi } from '@reduxjs/toolkit/query/react';
import apiRoutesV2 from 'src/config/api/routes';
import { appBaseQuery } from 'src/modules/shared/slices/helpers';
import { PlataformGuidePlace, PlataformGuideResponse } from './types';

export const PlataformGuideApi = createApi({
  reducerPath: 'PlataformGuideApi',
  baseQuery: appBaseQuery,
  tagTypes: Object.values(PlataformGuidePlace),
  endpoints: (builder) => ({
    getPlataformGuide: builder.query<PlataformGuideResponse, { place: PlataformGuidePlace }>({
      query: ({ place }) => ({
        url: apiRoutesV2.plataformGuide(place),
        method: 'GET',
      }),
      transformResponse: (response: { data: PlataformGuideResponse }) => {
        return response.data;
      },
    }),
  }),
});

export const { useGetPlataformGuideQuery } = PlataformGuideApi;
